import classNames from "classnames";
import React from "react";
import "./TextLabel.scss";

interface TextLabelProps {
  name: string;
  text: string;
  className?: string;
}

const TextLabel: React.SFC<TextLabelProps> = ({ name, text, className }) => {
  const fullClassName = classNames(
    "text-label",
    name && `text-label__${name}`,
    className
  );

  return (
    <span className={fullClassName}>
      <span className="text">{text}</span>
    </span>
  );
};

export default TextLabel;
